<svg
  width="17"
  height="11"
  viewBox="0 0 17 11"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.5 10.5461L2.03393e-08 0.999624L0.890045 0L8.5 8.55727L16.11 0.0103851L17 1.01001L8.5 10.5461Z"
    fill="#1C1C20"
  />
</svg>
